import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "../../pages/MainPage/MainPage";
import Services from "../../pages/Services/Services";
import Contact from "../../pages/Contact/Contact";
import FAQ from "../../pages/FAQ/FAQ";
import Galerie from "../../pages/Galerie/Galerie";
import Error from "../../pages/Error/Error";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ScrollToTop from "../ScrollTop/ScrollTop";
import Mandatory from "../../pages/MandatoryInformation/MandatoryInformation";

function RouterPlombier() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/FAQ" element={<FAQ />} />
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/mandatoryInformation" element={<Mandatory />} />
          <Route path="/*" element={<Error />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default RouterPlombier;
